import { ReactNode } from 'react';
import Dropzone, { DropzoneProps } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import { AddPhotoAlternate } from '@mui/icons-material';

interface FileUploadProps extends DropzoneProps {
  image?: ReactNode | undefined;
  label?: string;
  fileTypeDescription?: string;
}

const FileUpload = ({
  image = <AddPhotoAlternate sx={{ m: 2, fontSize: 32 }} />,
  label = 'Drag and drop or click here to upload.',
  fileTypeDescription = 'PNG, JPEG, WEBP, HEIC, GIF, SVG, GLTF, or MP4',
  accept = {
    'image/jpeg': ['.jpg', '.jpeg', '.jiff'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
    'image/bmp': ['.bmp'],
    'image/heif': ['.heif'],
    'image/heic': ['.heic'],
    'image/heif-sequence': ['.heifs'],
    'image/heic-sequence': ['.heics'],
    'image/gif': ['.gif'],
    'image/svg+xml': ['.svg'],
    'video/mp4': ['.mp4'],
    'model/gltf-binary': ['.gltf', '.glb'],
  },
  ...otherProps
}: FileUploadProps) => (
  <Dropzone accept={accept} minSize={1024} maxSize={3072000} {...otherProps}>
    {({ getRootProps, getInputProps }) => (
      <Box
        {...getRootProps()}
        sx={{
          width: '100%',
          textAlign: 'center',
          borderRadius: 2.5,
          border: (theme) => `1px dashed ${theme.palette.secondary.light}`,
          cursor: 'pointer',
          mt: 1,
        }}
      >
        <input {...getInputProps()} />
        {image}
        <Typography paragraph variant="body2">
          {label}
        </Typography>
        <Typography paragraph fontSize={11} color="text.secondary">
          {fileTypeDescription}
        </Typography>
      </Box>
    )}
  </Dropzone>
);

export default FileUpload;
